export default __webpack_public_path__ + "static/media/Darkband.59546bdc.jpg";